<template>
	<div class="item">
		<button @click="logout()" class="button"><span class="icon fastic-logout"></span><span class="label">{{ localizer.get("Account.Common.Logout") }}</span></button>
	</div>
</template>

<script setup lang="ts">
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{
	returnUrl?: string;
}>();

const localizer = Localizer;

const routes = (window as any).App.routes;

async function logout() {
	localStorage.removeItem("token");
	await Axios.post(routes.Account_User_Logout, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
	window.location.href = props.returnUrl ? props.returnUrl : "/";
}
</script>